import gql from 'graphql-tag';

import { YouthAthleteFragments } from 'fragments/YouthAthlete';

export const EditYouthAthleteMutation = gql`
  mutation EditYouthAthleteMutation($input: EditYouthAthleteInput!) {
    editYouthAthlete(input: $input) {
      success
      error
      youthAthlete {
        ...YouthAthleteAll
      }
    }
  }
  ${YouthAthleteFragments.all}
`;
